module.exports = __webpack_public_path__ + "img/planar_2d.d2e00845.png";